import { clsx } from 'clsx';
import * as React from 'react';

import styles from './OfferGalleryBubble.css';

interface IOfferGalleryBubbleProps {
  isRead?: boolean;
}

export const OfferGalleryBubble: React.FC<React.PropsWithChildren<IOfferGalleryBubbleProps>> = ({
  isRead,
  children,
}) => {
  return <div className={clsx(styles['bubble'], !isRead && styles['unread-bubble'])}>{children}</div>;
};
